import { ReactNode } from "react";

import Typography, { TypographyProps } from "../Typography";
import styles from "./styles.module.css";

type PageInfoHeaderCaptionProps = {
  caption: ReactNode;
  captionTag?: TypographyProps["tag"];
};

const PageInfoHeaderCaption = ({ caption, captionTag = "p" }: PageInfoHeaderCaptionProps) => (
  <Typography tag={captionTag} className={styles.caption}>
    {caption}
  </Typography>
);

PageInfoHeaderCaption.displayName = "DS.PageInfoHeaderCaption";

export default PageInfoHeaderCaption;
